import React from "react";

import { useRetrieveCostProfiles } from "@planzone/view-models";
import { Props } from "./types";
import { CostProfile } from "./costProfile";
import styles from "./styles.scss";

function CostProfiles(props: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    costProfiles,
    retrieveCostProfiles,
  } = useRetrieveCostProfiles();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveCostProfiles();
  }, []);

  return (
    <div className={styles.costProfiles}>
      {costProfiles.map((costProfile) => (
        <div key={costProfile.uuid} className={styles.costProfile}>
          <CostProfile costProfile={costProfile} />
        </div>
      ))}
    </div>
  );
}

export { CostProfiles };
